import { PageTransitionLinkMain } from '@components/PageTransitionLink/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'

export const NewSectionMain = styled.div``

export const Message = styled.div``

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  button, a {
    display: flex;
    align-items: center;
    border: 1px solid ${colors.charcoal};
    border-radius: 7rem;
    cursor: pointer;
    background: ${colors.charcoal};
    color: ${colors.white};
    width: 160px;
    padding: 6px;
    justify-content: center;
    text-decoration: unset;
    &.white {
      background: ${colors.mist};
      color: ${colors.charcoal};
    }
  }

`

export const OpenButton = styled.button`
`

export const OpenLink = styled.a`
`

export const LinksList = styled.ul`
  margin-top: 30px;
  list-style: disclosure-closed;
`

export const LinksListItem = styled.li`
  line-height: 36px;
`

export const LinkItem = styled.a`
`
